export const getBadgeColor = (lastName?: string) => {
  const colors = ["#fec5bb", "#d8e2dc", "#fec89a", "#bcd4e6", "#bee3db", "#fad2e1", "#ddbea9", "#cdc2eb"]

  return colors[`${lastName}`.charCodeAt(0) % colors.length]
}
